// src/models/NewEmp.jsx
import { useEffect, useState } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";
import { toast } from "react-toastify";

const NewEmp = ({ item, onAddDepart }) => {
    const [departments, setDepartments] = useState([]);
    const [branches, setBranches] = useState([]); // NEW
    const [formData, setFormData] = useState({
        user_id: '',
        fname: '',
        department: '',
        code: '',
        type1: 'user',
        gender: 'Male',
        mobile: '',
        email: '',
        dob: '',
        doj: '',
        // fees:'',
        address_line1: '',
        branch_id: '', // NEW
        type: 'employee',

        alertMsg: '',
        alertMsgTyp: '',
        isAlert: false,
    });
    const [ldata, setLdata] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const fd = new FormData();
        fd.append('user_id', formData.user_id);
        fd.append('fname', formData.fname);
        fd.append('department', formData.department);
        fd.append('code', formData.code);
        fd.append('type', "employee");
        fd.append('type1', "employee");
        fd.append('gender', formData.gender);
        fd.append('mobile', formData.mobile);
        fd.append('email', formData.email);
        fd.append('dob', formData.dob);
        fd.append('doj', formData.doj);
        // fd.append('fees', formData.fees);
        fd.append('address_line1', formData.address_line1);
        fd.append('branch_id', formData.branch_id || ''); // NEW
        fd.append('user_cre_by', ldata.user_id);

        try {
            const response = await axios.post(AppConst.BASE_URL + AppConst.addUserUrl, fd, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });

            if (response.data.status) {
                setFormData(prev => ({
                    ...prev,
                    isAlert: true,
                    alertMsg: response.data.success,
                    alertMsgTyp: response.data.type,
                }));
                document.getElementById("closeBt45").click();
                onAddDepart();
            } else {
                setFormData(prev => ({
                    ...prev,
                    isAlert: true,
                    alertMsg: response.data.success,
                    alertMsgTyp: response.data.type,
                }));
            }
        } catch (error) {
            setFormData(prev => ({
                ...prev,
                isAlert: true,
                alertMsg: "Failed",
                alertMsgTyp: "danger",
            }));
        }
    };

    useEffect(() => {
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) setLdata(JSON.parse(storedData));

        if (item != null && item != undefined) {
            setFormData(prev => ({
                ...prev,
                fname: item.fname,
                user_cre_by: item.user_cre_by,
                department: item.department,
                code: item.code,
                type: item.type,
                type1: item.type1,
                gender: item.gender,
                mobile: item.mobile,
                email: item.email,
                dob: item.dob,
                doj: item.doj,
                // fees: item.fees,
                address_line1: item.address_line1,
                branch_id: item.branch_id || '', // NEW
                user_id: item.user_id,
            }));
        } else {
            setFormData(prev => ({
                ...prev,
                fname: "",
                user_cre_by: "",
                department: "",
                code: "",
                type1: "",
                gender: "",
                mobile: "",
                email: "",
                dob: "",
                doj: "",
                // fees: "",
                address_line1: "",
                branch_id: "", // NEW
                user_id: ""
            }));
        }
    }, [item]);

    const fetchRoles = async () => {
        try {
            const response = await axios.get(AppConst.BASE_URL + AppConst.GetAllRole);
            if (response.data.status) setDepartments(response.data.list);
        } catch (err) {
            toast.error("Error fetching roles");
        }
    };

    // NEW: load branches so we can decide whether to show the branch dropdown
    const fetchBranches = async () => {
        try {
            const fd = new FormData();
            fd.append('page_no', 'none');
            const response = await axios.post(AppConst.BASE_URL + AppConst.getBranchListUrl, fd, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            if (response.data && response.data.status) {
                setBranches(Array.isArray(response.data.records) ? response.data.records : []);
            }
        } catch (err) {
            // silently ignore — if it fails, branch dropdown just won't show
            console.error("fetchBranches error", err);
        }
    };

    useEffect(() => {
        fetchRoles();
        fetchBranches();
    }, []);

    // show the branch dropdown ONLY if there is at least one branch
    const hasBranches = branches.length > 0;

    return (
        <div className="modal fade" id="showModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered modal-lg">
                <div className="modal-content">
                    <div className="modal-header bg-light p-3">
                        <h5 className="modal-title" id="exampleModalLabel">&nbsp;</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" id="close-modal"></button>
                    </div>
                    <form className="tablelist-form" onSubmit={handleSubmit}>
                        <div className="modal-body">
                            <div className="row gy-4 mb-3">
                                <div className="col-md-6">
                                    <div id="modal-id">
                                        <label className="form-label">Department</label>
                                        <select
                                            value={formData.department}
                                            onChange={(e) => setFormData({ ...formData, department: e.target.value })}
                                            className="form-select"
                                            required
                                        >
                                            <option value="">Select Department</option>
                                            {departments.map((dept) => (
                                                <option key={dept.id} value={dept.id}>
                                                    {dept.role_name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label">Employee Code</label>
                                    <input className="form-control" name="code" onChange={handleChange} value={formData.code} placeholder="Code" type="text" />
                                </div>

                                {/* ---- BRANCH SELECT: only rendered when branches exist ---- */}
                                {hasBranches && (
                                    <div className="col-md-6">
                                        <label className="form-label">Branch</label>
                                        <select
                                            className="form-select"
                                            name="branch_id"
                                            value={formData.branch_id}
                                            onChange={handleChange}
                                        >
                                            <option value="">Select Branch</option>
                                            {branches.map((b) => (
                                                <option key={b.branch_id} value={b.branch_id}>
                                                    {b.branch_name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                )}

                                <div className="col-md-6">
                                    <label className="form-label">Name</label>
                                    <input className="form-control" name="fname" onChange={handleChange} value={formData.fname} placeholder="Name" type="text" />
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label">Gender</label>
                                    <select className="form-control" name="gender" onChange={handleChange} value={formData.gender}>
                                        <option value="Male">Male</option>
                                        <option value="Female">Female</option>
                                        <option value="Other">Other</option>
                                    </select>
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label">Mobile</label>
                                    <input className="form-control" name="mobile" onChange={handleChange} value={formData.mobile} placeholder="Mobile" type="text" />
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label">Email Address</label>
                                    <input className="form-control" name="email" onChange={handleChange} value={formData.email} placeholder="Email Address" type="text" />
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label">DOB</label>
                                    <input className="form-control" name="dob" onChange={handleChange} value={formData.dob} type="date" />
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label">DOJ</label>
                                    <input className="form-control" name="doj" onChange={handleChange} value={formData.doj} type="date" />
                                </div>

                                <div className="col-md-12">
                                    <label className="form-label">Address</label>
                                    <textarea className="form-control" name="address_line1" onChange={handleChange} value={formData.address_line1} placeholder="Address"></textarea>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className="hstack gap-2 justify-content-end">
                                <button type="button" id="closeBt45" className="btn btn-light" data-bs-dismiss="modal">Close</button>
                                {(formData.user_id.length > 0)
                                    ? <button type="submit" className="btn btn-success" id="edit-btn">Update</button>
                                    : <button type="submit" className="btn btn-success" id="edit-btn">Add</button>}
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default NewEmp;